const effectsConfig = {
  snowfall: false,  // ❄️ Schneefall aktivieren/deaktivieren
  lightning: false, // ⚡ Blitze aktivieren/deaktivieren
  fireball: false, //🔥 Feuerball aktivieren/deaktivieren
};

export default effectsConfig;
